module.exports = __webpack_public_path__ + "img/kiss-beam.0e7bf1c0.svg";